import React from 'react';
import { connect } from 'react-redux';
import Grid from '../../../MuiGrid/Grid';
import { Box } from '@origin-digital/layout';
import { AlertBox } from '@origin-digital/style-guide';

import { FormErrorSummaryProps } from './FormErrorSummary.types';

export const FormErrorSummary: React.FunctionComponent<FormErrorSummaryProps> = ({
  ...props
}: FormErrorSummaryProps): JSX.Element | null => {
  const { error, errorMessage, marginBottom, marginTop } = props;

  if (!error) {
    return null;
  }

  return (
    <Box marginBottom={marginBottom} marginTop={marginTop}>
      <Grid container justify="center" direction="row">
        <Grid item sm={12} md={8} lg={8}>
          <AlertBox type="error" message={errorMessage} />
        </Grid>
      </Grid>
    </Box>
  );
};

const mapStateToProps = (state: any) => ({
  error: state.request.error,
  errorMessage: state.request.message
});

export default connect(mapStateToProps)(FormErrorSummary);
